<template>
  <div>
    <b-navbar fixed="top" toggleable="lg" class="p-1" type="light"  style="background:#81C784 !important ;border-bottom:1px solid #dcdcdc">
      
        <b-navbar-brand to="/"><img style="width:3rem" src="img/head.png" alt=""></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
            <b-nav-item  to="/" class="mr-1">Home</b-nav-item>
            <b-nav-item class="mr-1"  to="/all_posts" >Posts</b-nav-item>
            <b-nav-item class="mr-1" to="/ijtmae-qurbani">Ijtamae Qurbani</b-nav-item>
            <b-nav-item class="mr-1" to="/sadqah-and-aqiqa">Sadqah Aqiqa</b-nav-item>
            <b-nav-item class="mr-1" v-if="loggedUser==null" to="/login">Login</b-nav-item>
            <b-nav-item class="mr-1" to="/dashboard" v-if="loggedUser!=null">Dashboard</b-nav-item>
            <b-nav-item class="mr-1" @click="logout" v-if="loggedUser!=null">Logout</b-nav-item>
            <b-button variant="success" v-if="loggedUser==null" @click="redirect(self,'register')"  ><i class="fa fa-user" aria-hidden="true"></i> Register</b-button>

            <b-button class="ml-1" variant="success" @click="showModal()"  ><i class="fa fa-camera" aria-hidden="true"></i> Sell</b-button>

        </b-navbar-nav>
        </b-collapse>
  </b-navbar> 
    <b-modal id="sell-dialog" hide-footer="" >
       <template v-slot:modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <h5>Upload your Ad</h5>
      <b-button size="sm" variant="outline-success" @click="close()">
        Cancel
      </b-button>
    </template>
        <div  style="display:flex;cursor:pointer;" @click="routeit('AUDIO')">
            <img src="img/sellmodal/dslr-camera.png" width="60" alt="">
            <h5 class="mt-3 ml-3">Upload Image</h5>
        </div>
        <div style="display:flex;cursor:pointer;" @click="routeit('VIDEO')" class="mb-4">
            <img src="img/sellmodal/video-camera.png" width="60" alt="">
            <h5 class="mt-3 ml-3">Upload Video</h5>
        </div>

  </b-modal>
 </div> 
</template>

<script>
import globalfuns from '../mixins/globalfuns'
import {mapGetters} from 'vuex'
export default {
  name:'TopNav',
  mixins:[globalfuns],
  computed:{
  ...mapGetters(['loggedUser','FB'])  
  },
  created(){
    this.self=this
  },
  data(){
    return{
      type:'image',
      self:''
    }
  },
  methods:{
    routeit(arg) { 
      this.type=arg
      this.$bvModal.hide('sell-dialog')
      this.$router.push({name:'NewPost',params:{type:arg}})
    },
    logout(){
      this.$store.dispatch("updateOnlineStatus",{id:this.loggedUser.id,status:false})

      this.$store.commit("logout")
      this.FB.logout()

      this.$router.push({path:'/'})
    },
    showModal(){
      if(this.loggedUser!=null){
        this.$bvModal.show('sell-dialog')	
      }
      else{
        this.$store.commit('setNotifications',{message:'Login before creating Ads',type:'error'})
      }
    }

  }
}
</script>

<style>
#sell-dialog___BV_modal_content_{
      border-radius: 22px !important;
}

</style>
